import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

function useStateWithRef<T>(
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>, React.RefObject<T>] {
  const [state, setState] = useState<T>(initialValue)
  const stateRef = useRef<T>(initialValue)

  useEffect(() => {
    stateRef.current = state
  }, [state])

  return [state, setState, stateRef]
}

export default useStateWithRef
